var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    {
      staticClass: "sezar-attribute",
      class: { active: _vm.active },
      attrs: { contenteditable: false },
    },
    [
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sezar-attribute-popover",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("AttributePicker", {
                attrs: {
                  "default-selected": _vm.node.attrs.name,
                  pick: _vm.onPicked,
                  "whatsapp-mode": _vm.node.attrs.whatsappMode,
                  "allowed-attributes": _vm.parseAllowedAttributes(),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "logos pop-content w-100",
              on: {
                click: function ($event) {
                  _vm.active = true
                },
              },
            },
            [
              _c("AttributeIconPreview", {
                attrs: { attribute: _vm.node.attrs.name },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "ml-2" },
                [
                  _c("AttributeLabel", {
                    attrs: { attribute: _vm.node.attrs.name },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }